import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Classification } from '@synergy/models';
import { noop } from '@synergy/utils';

export class ClassificationsApi {
    constructor(protected baseUrl: string) {}

    public cget = async (params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<Classification>>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/classifications`, { params }),
            response => response.data
        );
    };

    public cgetAll = async (): Promise<ApiResult<PaginatedResponse<Classification>>> => {
        return safeRequest(
            () => request.get<Classification[]>(`${this.baseUrl}/all-classifications`),
            response => ({
                items: response.data,
                total: response.data.length,
                page: 1,
                limit: response.data.length,
            })
        );
    };

    public updateClassification = async (classification: Classification): Promise<ApiResult<Classification>> => {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/classifications/${classification.id}`, classification),
            response => response.data
        );
    };

    public createClassification = async (
        classification: Partial<Classification>
    ): Promise<ApiResult<Classification>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/classifications`, classification),
            response => response.data
        );
    };

    public deleteClassification = async (classificationId: number): Promise<ApiResult> => {
        return safeRequest(() => request.delete(`${this.baseUrl}/classifications/${classificationId}`), noop);
    };
}
